export const css = {
    root: '_3YYachUs',
    heading: 'Rl3UQS1z',
    row: '_2B51h_vU',
    product: '_7KNUaful',
    primary: '_3zQf1fqE',
    secondary: '_1ardyXl3',
    sticky: '_2wIsMqra',
    leading: 'fLrHOOjq',
    title: '_2GeTOasd',
    actions: 'x_ddU3G9',
    logo: '_2ZRzYkD7',
    trailing: '_3j2Irq8S',
    spacer: '_2tzMMLOo',
    hamburgerWrapper: '_9jPDj1sB',
    hamburger: 'kr7RR6Pf',
    hamburgerText: '_17EjDKdl',
    hamburgerMenu: '_2lTaRzXw',
    hamburgerMenuItem: 'KqOwL_0X',
    quizSelect: '_2sMvsEnm',
    quizSelectBlock: '_1pEu4NAz',
    hideCountdownBlock: '_1Ea_DFiv',
    quizSelectChoice: 'I1bH4Nu9',
    quizSelectHidden: '_2ZU_Ryu3',
    examCalendar: '_2zWSf8E3',
    home: 'keZRdPCt',
    nav: '_1jpUOKH_',
    avatar: '_1MPwyzgK',
    selectFadeOut: '_1Z8T7r6H',
    ' _key': 'afcpe-theme/afcpe/micro/lcc-app/heading'
};
export default css;
